import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building2 } from 'lucide-react';

export function Impressum() {
  return (
    <div className="min-h-screen bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/login"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Zurück zur Anmeldung
        </Link>

        <div className="bg-card rounded-lg shadow-sm border border-border p-8">
          <div className="flex items-center mb-8">
            <Building2 className="h-8 w-8 text-primary mr-3" />
            <h1 className="text-3xl font-bold text-foreground">Impressum</h1>
          </div>

          <div className="space-y-6 text-foreground">
            <section>
              <p className="text-sm text-muted-foreground mb-4">Angaben gemäß § 5 TMG</p>
              <p className="font-semibold text-lg">Ali Tombul</p>
              <p className="text-muted-foreground">AllFlowX</p>
              <p className="text-muted-foreground">Karl-Joos-Strasse 8</p>
              <p className="text-muted-foreground">70806 Kornwestheim</p>
            </section>

            <section className="pt-4 border-t border-border">
              <h2 className="font-semibold text-base mb-3">Kontakt</h2>
              <p className="text-muted-foreground">
                Telefon:{' '}
                <a href="tel:+491727012056" className="text-primary hover:underline">
                  +49 172 7012056
                </a>
              </p>
              <p className="text-muted-foreground">
                E-Mail:{' '}
                <a href="mailto:support@allflowx.de" className="text-primary hover:underline">
                  support@allflowx.de
                </a>
              </p>
            </section>

            <section className="pt-4 border-t border-border">
              <h2 className="font-semibold text-base mb-3">Umsatzsteuer-ID</h2>
              <p className="text-muted-foreground">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
              </p>
              <p className="text-foreground font-medium mt-1">DE319849876</p>
            </section>

            <section className="pt-4 border-t border-border">
              <h2 className="font-semibold text-base mb-3">Berufsbezeichnung</h2>
              <p className="text-muted-foreground">Betreiber einer Online-Plattform</p>
            </section>

            <section className="pt-4 border-t border-border">
              <h2 className="font-semibold text-base mb-3">
                Verbraucherstreitbeilegung
              </h2>
              <p className="text-muted-foreground leading-relaxed text-sm">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground">
              Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
